import { HTMLAttributes } from 'react';
import { useJoveBreakpoint } from '@jove-frontend/uikit';
import { ExpandMore } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from '@mui/material';
import clsx from 'clsx';

type BrokerQuestionsViewProps = HTMLAttributes<HTMLDivElement> & {
  info: {
    questionsTitle: string;
    questionsList: Array<{
      title: string;
      content: string;
    }>;
  };
};
const BrokerQuestionsView = (props: BrokerQuestionsViewProps) => {
  const { className, info } = props;
  const { isMobileLayout } = useJoveBreakpoint();

  return (
    <Box className={clsx(`flex flex-col items-center`, className)}>
      <Box
        className={clsx(
          'flex flex-col space-y-12',
          isMobileLayout ? 'w-full' : 'w-[960px] space-y-12'
        )}
      >
        <Typography
          variant="h4"
          className="text-primary-black text-center font-black"
        >
          {info?.questionsTitle}
        </Typography>
        <Box className="flex flex-1 flex-col space-y-5">
          {(info?.questionsList || []).map((item, index) => (
            <Accordion
              key={index}
              className="rounded-2xl border-none bg-white  py-3 font-black shadow-none before:hidden"
            >
              <AccordionSummary
                expandIcon={
                  <Box className="bg-grey-5 flex h-10 w-10 items-center justify-center rounded-full">
                    <ExpandMore />
                  </Box>
                }
                aria-controls="panel1a-content"
                id="panel1a-header"
                className="text-true-black border-none"
              >
                <Typography
                  variant="subtitle1"
                  className="text-true-black text-xl font-black"
                >
                  {item.title}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  variant="subtitle1"
                  className="text-true-black text-lg font-medium"
                >
                  {item.content}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default BrokerQuestionsView;
